import { WorkflowState } from '../../../types';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { DOCUMENTS_BASE_PATH } from '../constants/documentsBasePath';
import { buildHeadersFromDocumentParams } from '../logic/buildHeadersFromDocumentParams';
import { DocumentParams } from '../types/DocumentParams';

export const postDocumentTransition = async (
  constructPost: ConstructPost,
  documentId: string,
  documentParams: DocumentParams,
  transition: string,
): Promise<NonPaginatedResponse<WorkflowState> | undefined> =>
  constructPost(
    `${DOCUMENTS_BASE_PATH}/${documentId}/transition`,
    {
      data: { transition },
      headers: buildHeadersFromDocumentParams(documentParams),
    },
    { preventDefaultErrorToast: true },
  );
